var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:{ 'create-button--small': _vm.isMobile },attrs:{"color":"primary","to":_vm.path,"exact":""}},[(!_vm.isMobile)?_c('span',[_vm._v(_vm._s('New ' + _vm.text))]):_c('v-icon',{attrs:{"color":"light"}},[_vm._v(_vm._s(_vm.icon || 'add'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }